<template>
  <!-- Left panel with cover effect when hidden -->
  <f7-panel
    v-model:opened="isPanelOpened"
    left
    cover
    class="main-sidemenu"
  >
    <f7-view>
      <f7-page class="content-left-panel">
        <f7-block
          v-if="dataUserApp != null"
          class="content-left-panel-header"
        >
          <div class="content-left-panel-header__img">
            <img
              src="@/static/icons/ic_user.svg"
              class="img-imagenPrincipalTrabajador"
            >
          </div>
          <div class="content-left-panel-header__title">
            <span>{{ dataUserApp.UserName }}</span>
            <span>{{ t('common.user') }}</span>
          </div>
        </f7-block>

        <!-- List with icons -->
        <f7-list
          media-list
          class="content-list"
        >
          <f7-list-item
            link="/"
            view=".view-main"
            :title="t('sideMenu.common.home')"
            panel-close
            no-chevron
          >
            <template #media>
              <img
                src="@/static/icons/ic_home.svg"
                width="32"
              >
            </template>
          </f7-list-item>
          <f7-list-item
            link="#"
            :title="t('sideMenu.common.notifications')"
            panel-close
            no-chevron
            @click="emitOpenNotificationERP"
          >
            <template #media>
              <img
                src="@/static/icons/ic_notification.svg"
                width="32"
              >
            </template>
          </f7-list-item>
        </f7-list>

        <!-- Accordion list -->
        <f7-list
          v-for="item in routes"
          :key="item.Id"
          accordion-list
          class="left-panel-content"
        >
          <f7-list-item
            v-if="item.Procesos.length > 0 || (item.SubModulos && item.SubModulos.length > 0)"
            :title="item.Nombre ?? undefined"
            accordion-item
            accordion-item-opened
          >
            <template #media>
              <img
                :src="getIconUrl(item.Id)"
                :onerror="errorIcon"
                width="32"
              >
            </template>
            <f7-accordion-content>
              <f7-list
                v-for="itemAcordeon in item.Procesos"
                :key="itemAcordeon.Id"
              >
                <f7-list-item
                  :title="itemAcordeon.Nombre ?? undefined"
                  :link="itemAcordeon.Formulario ?? undefined"
                  view=".view-main"
                  panel-close
                  no-chevron
                />
              </f7-list>
              <f7-list
                v-for="subModulos in item.SubModulos"
                :key="subModulos.Id"
                accordion-list
              >
                <f7-list-item
                  :title="subModulos.Nombre ?? undefined"
                  accordion-item
                  accordion-item-opened
                >
                  <template #media>
                    <img
                      :src="getIconUrl(subModulos.Id)"
                      :onerror="errorIcon"
                      width="32"
                      class="margin-left"
                    >
                  </template>
                  <f7-accordion-content>
                    <f7-list
                      v-for="subModuloSubP in subModulos.Procesos"
                      :key="subModuloSubP.Id"
                    >
                      <f7-list-item
                        :title="subModuloSubP.Nombre ?? undefined"
                        :link="subModuloSubP.Formulario ?? undefined"
                        view=".view-main"
                        panel-close
                        no-chevron
                      />
                    </f7-list>
                  </f7-accordion-content>
                </f7-list-item>
              </f7-list>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>

        <!-- Developer Options -->
        <f7-list
          v-if="hasInternalConfigurationsAccess"
          accordion-list
          class="left-panel-content"
        >
          <f7-list-item
            :title="t('sideMenu.common.developerOptions')"
            accordion-item
            accordion-item-opened
          >
            <template #media>
              <img
                src="@/static/icons/ic_options.svg"
                width="27"
              >
            </template>
            <f7-accordion-content>
              <f7-list>
                <f7-list-item
                  link="/testComponent"
                  view=".view-main"
                  :title="t('common.components')"
                  panel-close
                  no-chevron
                />
              </f7-list>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>

        <!-- List with icons -->
        <f7-list
          media-list
          class="content-list"
        >
          <f7-list-item
            view=".view-main"
            link="/settings/"
            :title="t('common.settings')"
            panel-close
            no-chevron
          >
            <template #media>
              <img
                alt="iconHome"
                src="@/static/icons/ic_home.svg"
                width="32"
              >
            </template>
          </f7-list-item>
          <f7-list-item
            v-if="allowSettingWorkEnvironment"
            link="/"
            :title="t('common.workEnvironment')"
            panel-close
            no-chevron
            view=".view-main"
            @click="workEnvironmentPopupRef?.openPopup()"
          >
            <template #media>
              <img
                src="@/static/img/ic_setting.svg"
                width="32"
              >
            </template>
          </f7-list-item>
          <f7-list-item
            link="/"
            :title="t('common.signOut')"
            panel-close
            no-chevron
            view=".view-main"
            @click="handleLogout"
          >
            <template #media>
              <img
                src="@/static/icons/ic_logout.svg"
                width="27"
              >
            </template>
          </f7-list-item>
        </f7-list>
      </f7-page>
    </f7-view>

    <PCWorkEnvironmentPopup
      v-if="allowSettingWorkEnvironment"
      ref="workEnvironmentPopupRef"
    />
  </f7-panel>
</template>

<script setup>
// @ts-check
import { storeToRefs } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { HiDialog } from '@/js/common/HINotificationSupport';
import { sleep } from '@/js/utils/sleep';
import {
  computed,
  defineAsyncComponent,
  onMounted,
  ref,
  shallowRef,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { IS_DEVELOPMENT } from '@/js/common/constants';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

/** @import { PropType, ShallowRef } from 'vue' */

defineProps({

  dataUserApp: {
    type: /** @type {PropType<{ UserName: string; } | null>} */ (
      Object
    ),
    default: null,
  },
});

const emit = defineEmits([
  'logout',
  'open-notification-erp',
]);

const PCWorkEnvironmentPopup = defineAsyncComponent(() => import('@/components/common/PCWorkEnvironmentPopup.vue'));

const iconsContext = import.meta.webpackContext('@/static/icons', {
  recursive: false,
  regExp: /.svg$/,
});

const allowSettingWorkEnvironment = useParamRef('PermitirEstablecerEntornoDeTrabajo');
const hasInternalConfigurationsAccess = useSettingRef('ConfiguracionesInternas.AccesoHabilitado');

const {
  userAccesivility,
} = storeToRefs(useAppConfigStore());

const { t } = useI18n();

const errorIcon = ref(`this.onerror=null; this.src='${getDefaultIcon()}'`);

const isPanelOpened = ref(false);
const developmentMode = ref(false);

/** @type {ShallowRef<InstanceType<typeof PCWorkEnvironmentPopup> | null>} */
const workEnvironmentPopupRef = shallowRef(null);

const routes = computed(() => userAccesivility.value ?? []);

async function handleLogout() {
  isPanelOpened.value = false;
  HiDialog.Preloader(true, t('sideMenu.info.signingOut'), false);

  await sleep(1000); // elimina el panel-backdrop-in de la view principal.
  emit('logout');

  HiDialog.Preloader(false);
}

function emitOpenNotificationERP() {
  emit('open-notification-erp');
}

function getDefaultIcon() {
  try {
    const imgUrl = /** @type {string} */ (iconsContext('./ic_task-list2.svg'));
    return imgUrl;
  } catch (error) {
    return '';
  }
}

/**
 * Gets the icon url of the process or module.
 * @param {number} id - The ID of of the process or module.
 * @returns {string} - The icon url of the process or module.
 */
function getIconUrl(id) {
  try {
    const imgUrl = /** @type {string} */ (iconsContext(`./${id}.svg`));
    return imgUrl;
  } catch (error) {
    return '';
  }
}

onMounted(() => {
  developmentMode.value = IS_DEVELOPMENT;
});
</script>

<style scoped lang="scss">
.main-sidemenu {
  --f7-panel-left-width: 360px;
  --f7-block-margin-vertical: 15px;
  --f7-list-media-item-padding-vertical: 14px;
  --f7-list-margin-vertical: 0;
  --f7-list-bg-color: #fff;
  --f7-list-item-padding-horizontal: 8px !important;
  --f7-list-item-min-height: 48px;

  .accordion-item-opened > .accordion-item-content {
    border-bottom: unset;
    padding-bottom: unset;
  }
}

.content-left-panel-header {
  display: flex;
  align-items: center;
  background: url("@/static/img/bg_menu-header.png") no-repeat;
  background-size: 100%;
  margin: 0;
  padding-top: var(--f7-block-margin-vertical);
  padding-bottom: var(--f7-block-margin-vertical);
  border-bottom: 1px solid var(--his-tierra-white);

  &__img {
    img {
      width: 50px;
      height: 50px;
    }
  }

  &__title {
    padding-left: 15px;
    flex-direction: column;
    display: flex;

    span {
      &:first-child {
        color: var(--his-dark-blue);
        font-size: 17px;
        font-weight: 500;
      }

      &:nth-child(2) {
        color: var(--his-oliva);
        font-size: 13px;
        font-weight: 400;
      }
    }
  }
}

:deep(.content-list) {
  --f7-list-media-item-padding-horizontal: 8px;

  .item-inner::after {
    height: 0;
  }

  .media-item {
    > .item-link {
      .item-content {
        .item-media {
          display: flex;

          img {
            width: 32px;
          }
        }

        .item-inner {
          display: flex;
          align-items: center;
          margin-left: 8px;

          .item-title {
            font-size: 16px;
            font-weight: 500;
            color: #003d3e;
          }
        }
      }
    }
  }
}

:deep(.left-panel-content) {
  ul::after,
  ul::before {
    height: 0;
  }

  .accordion-item {
    --f7-list-item-media-margin: 8px;
    --f7-list-item-padding-horizontal: 8px;
    --f7-list-item-title-line-height: 1.3;

    > .item-link {
      background-color: var(--his-oliva-tint);
      border-top: 0;
      border-bottom: 0.5px solid var(--f7-list-item-border-color);

      .item-content {
        .item-inner {
          &::before {
            color: var(--his-dark-blue);
          }

          .item-title {
            font-size: 16px;
            font-weight: 600;
            color: #2f4859;
          }
        }
      }
    }

    .accordion-item-content {
      --f7-list-item-padding-horizontal: 48px;

      .item-content {
        .item-inner {
          .item-title {
            color: #003d3e;
            font-size: 16px;
            font-weight: 400;
          }
        }
      }

      .accordion-list {
        --f7-typography-margin: 18px;

        .accordion-item-content {
          --f7-list-item-padding-horizontal: 64px;

          .accordion-item {
            > .item-link {
              background-color: var(--his-ajo-tint);
            }
          }
        }
      }
    }
  }

  .list .item-link .item-inner::before,
  .accordion-item > .item-link .item-content .item-inner::before {
    right: 16px;
  }

  .item-link .item-inner {
    padding-right: 16px;
  }
}
</style>
